import React from 'react';
import './ComingSoonAd.scss';
import LinkImage from '../LinkImage';

const ComingSoonAd = ({
	imageSrc,
	imageAlt,
	imageTitle,
	imageSubtitle,
	contentTitle,
	generalTitle,
	contentBody,
	side,
	imageLink,
	footer,
}) => {
	const image = imageSrc.includes('.svg') ? require(`../../assets/icons/${imageSrc}`) : require(`../../assets/images/${imageSrc}`)
	return side && side === 'left' ? (
		<React.Fragment>
			<div className='coming-soon-ad-container'>
				<div className='coming-soon-ad'>
					{generalTitle && <h2 style={{ textAlign: 'center' }}>{generalTitle}</h2>}
					<div className='row'>
						<div className='coming-soon-item col-sm-12 col-md-8'>
							{contentTitle && <h2>{contentTitle}</h2>}
							<div className='text'>{contentBody}</div>
						</div>
						<div className='coming-soon-item left col-sm-12 col-md-4 left-border'>
							<h2>{imageTitle}</h2>
							<LinkImage
								linkSrc={imageLink}
								imageSubtitle={imageSubtitle}
								imageAlt={imageAlt}
								imageSrc={image}
							/>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	) : (
		<React.Fragment>
			<div className='coming-soon-ad-container'>
				<div className='coming-soon-ad'>
					{generalTitle && <h2 style={{ textAlign: 'center' }}>{generalTitle}</h2>}
					<div className='row'>
						<div className='coming-soon-item left col-sm-12 col-md-4 right-border'>
							<h2>{imageTitle}</h2>
							<LinkImage
								linkSrc={imageLink}
								imageSubtitle={imageSubtitle}
								imageAlt={imageAlt}
								imageSrc={image}
							/>
						</div>
						<div className='coming-soon-item col-sm-12 col-md-8'>
							{contentTitle && <h2>{contentTitle}</h2>}
							<div className='text'>{contentBody}</div>
						</div>
						<div>{footer}</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default ComingSoonAd;
